import { render, staticRenderFns } from "./ViewAuthStatus.vue?vue&type=template&id=86bf724c&scoped=true&"
import script from "./ViewAuthStatus.vue?vue&type=script&lang=js&"
export * from "./ViewAuthStatus.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "86bf724c",
  null
  
)

export default component.exports